export enum BREAKS {
  /* Mobile */
  MOBILE = '(max-width: 750px)',
  /* Tablets */
  TABLET_SMALL_NOTEBOOK = '(min-width: 768px) and (max-width: 1279px)',
  /* Desktop */
  DESKTOP = '(min-width: 1280px) and (max-width: 1439px)',
}
